import {hideUsernameError} from "./hideUsernameError";

export const setSuggestion = (e: Event) => {
	const suggestionEl = e.currentTarget as HTMLSpanElement;
	const suggestionInputEl = document.querySelector('[data-username-change]') as HTMLInputElement;
	suggestionInputEl.value = suggestionEl.innerText;
	hideUsernameError();
}
